module.exports = __webpack_public_path__ + "rgfw3.png?a16d21bd17ee84ef0f9b73ea312f714c";


//////////////////
// WEBPACK FOOTER
// ./static/assets/rgfw3.png
// module id = 254
// module chunks = 0